import { FilterOperatorKey } from "../enum/report-filter.enum";

export enum ReportNoDataMessages {
    SelectScopeAndRun = "Select a scope at the top left and run the report to begin using this report",
    ErrorFilterNoResult = "The filters you applied didn’t produce any results. Please revisit the filter conditions.",
  }

  export const FILTER_OPERATORS = [
    { key: FilterOperatorKey.EQUALS, label: 'equal to', value: ' = ' },
    { key: FilterOperatorKey.LT, label: 'less than', value: ' < ' },
    { key: FilterOperatorKey.GT, label: 'greater than', value: ' > ' },
    { key: FilterOperatorKey.LTE, label: 'less than or equal to', value: ' <= ' },
    { key: FilterOperatorKey.GTE, label: 'greater than or equal to', value: ' >= ' },
    { key: FilterOperatorKey.NOT_EQUALS, label: 'not equal to', value: ' <> ' },
    { key: FilterOperatorKey.LIKE, label: 'check if a value matches a pattern (case sensitive)', value: ' LIKE ' },
    { key: FilterOperatorKey.ILIKE, label: 'check if a value matches a pattern (case insensitive)', value: ' ILIKE ' },
    { key: FilterOperatorKey.AND, label: 'logical AND', value: ' AND ' },
    { key: FilterOperatorKey.OR, label: 'logical OR', value: ' OR ' },
    { key: FilterOperatorKey.IN, label: 'check if a value is in a range of values', value: ' IN ' },
    { key: FilterOperatorKey.BETWEEN, label: 'check if a value is between a range of values', value: ' BETWEEN ' },
    { key: FilterOperatorKey.NOT_BETWEEN, label: 'negative result for BETWEEN', value: ' NOT BETWEEN ' },
    { key: FilterOperatorKey.IS_NULL, label: 'check if a value is NULL', value: ' IS NULL ' },
    { key: FilterOperatorKey.NOT_NULL, label: 'check if a value is NOT NULL', value: ' NOT NULL ' },
    { key: FilterOperatorKey.NOT_LIKE, label: 'negative result for LIKE', value: ' NOT LIKE ' },
    { key: FilterOperatorKey.NOT_IN, label: 'negative result for IN', value: ' NOT IN ' },
    { key: FilterOperatorKey.STARTS_WITH, label: 'check if a value starts with given string', value: ' STARTS_WITH ' },
    { key: FilterOperatorKey.ENDS_WITH, label: 'check if a value ends with given string', value: ' ENDS_WITH ' },
  ];